import { FC } from "react";
import styles from "./Offers.module.scss";
import SniperBotOffer from "./SniperBotOffer";

const Offers: FC = () => {
    return (
        <section id="offers" className={styles.offers}>
            <div className={styles.headline + " mb-4"}>
                <h2 className={styles.title}>
                    What <span className={styles.secondaryColor}>nest</span> offers?
                </h2>
                <p className={styles.subtitle}>Speed. Simplicity. Availability</p>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-6 w-full h-fit ">
                <SniperBotOffer
                    imageName="exchange"
                    className="md:aspect-square aspect-square"
                    title="Fast exchange"
                    description="Switch the standard swap to fast transactions with one click"
                />
                <SniperBotOffer
                    imageName="sniper"
                    className="md:col-span-2 aspect-square md:aspect-auto"
                    title="Sniper bot"
                    description="Launch a sniperbot to get even more profit from your operations, don't keep an eye on the whales, lead them"
                />
                <SniperBotOffer
                    imageName="limit"
                    className="md:col-span-2 aspect-square md:aspect-auto"
                    title="Limit orders"
                    description="Trade limit orders with any trading pair on TON"
                />
                <SniperBotOffer
                    imageName="meme"
                    className="aspect-square"
                    title="Mempad swap"
                    description="Trade memes through a fast exchanger"
                />
                <SniperBotOffer
                    imageName="transaction"
                    className="md:row-span-2 md:aspect-[3/4] md:min-w-full aspect-[3/4]"
                    title="Transaction protection"
                    description="Protect your transactions from frontrunning and scams with advanced security features"
                />
                <SniperBotOffer
                    imageName="whale"
                    className="aspect-square md:aspect-auto"
                    title="Whale tracking"
                    description="Track whale movements and gain insights into large market players"
                />
                <SniperBotOffer
                    imageName="scam"
                    className="aspect-square md:aspect-auto"
                    title="Scam detector"
                    description="Detect and avoid scam tokens and suspicious activity automatically"
                />
                <SniperBotOffer
                    imageName="swap"
                    className="md:col-span-2 aspect-square md:aspect-auto"
                    title="Multi-swap"
                    description="Swap multiple tokens in a single transaction for maximum efficiency"
                />
            </div>
        </section>
    );
};

export default Offers;
